import { render } from "./TermsOfUse.vue?vue&type=template&id=ba98ee9c&scoped=true"
const script = {}

import "./TermsOfUse.vue?vue&type=style&index=0&id=ba98ee9c&lang=css"
import "./TermsOfUse.vue?vue&type=style&index=1&id=ba98ee9c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba98ee9c"]])

export default __exports__